// extracted by mini-css-extract-plugin
export default {"tabOne__wrapper":"Tab_tabOne__wrapper__yuFzR","keyboard":"Tab_keyboard__Hkq80","keyRow":"Tab_keyRow__nKcne","enter__wrapper":"Tab_enter__wrapper__XVAEu","enter":"Tab_enter__HIp2y"};